import {materials} from "./materials";

export const technologyMaterials = [
    {
        id: 1,
        materials: materials,
        menuItemId: 2
    },
]
